// @flow

import Service from "app/services/Service";

class UserService extends Service {
    static base = "/user";

    updatePreference(preference: string, value: any): Promise<*> {
        if (typeof value === "boolean") {
            value = value ? 1 : 0;
        }
        return this.http.put(
            "update-preference",
            this.toSearchParams({ preference, value })
        );
    }

    requestEarlyAccess() {
        return this.http.post("/request-early-access");
    }

    setWatchTour() {
        return this.updatePreference("watch_tour", true);
    }

    setFirstCardSuccessMessage() {
        return this.updatePreference("first_card_message", true);
    }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/app/services/UserService.js